
export const q2Tenants = {
    q2: "q2",
    camden: "camden",
    kleberg: "kleberg"
};

export const isQ2ServiceProvider = (props, fromProps = true) => {
    if (!fromProps) {
        return Object.values(q2Tenants).includes(props);
    }
    return Object.values(q2Tenants).includes(props?.state?.theme?.values?.tenantFullName);
}

export const isCamdenTenant = (props, fromProps = true) => {
    const camdenTenants = {camden : "camden"};
    if (!fromProps) {
        return Object.values(camdenTenants).includes(props);
    }
    return Object.values(camdenTenants).includes(props?.state?.theme?.values?.tenantFullName);
}

export const isKlebergTenant = (props, fromProps = true) => {
    const klebergTenants = {kleberg: "kleberg"};
    if (!fromProps) {
        return Object.values(klebergTenants).includes(props);
    }
    return Object.values(klebergTenants).includes(props?.state?.theme?.values?.tenantFullName);
}

export const cardControlsRedirectQ2 = (props) => {
    if (isQ2ServiceProvider(props)) {
        if (window.tecton && window.tecton.actions) {
            window.tecton.actions.navigateTo('dynamicForm.show', ['BaseCardManagementDCI'])
        } else {
            console.error(`tecton not able to navigate`)
        }
    }
}


export const retrieveUserInfoQ2 = (props) => {
    if (isQ2ServiceProvider()) {
        if (window?.tecton?.sources) {
            console.log("tecton global calling requestExtensionData retrieve_user_info")
            window.tecton.sources.requestExtensionData({
                route: 'retrieve_user_info',
                body: null
            }).then((xhr) => {
                // Do something with response
                console.log(xhr);
            }).catch((xhr) => {
                console.log(xhr);
                // Fires for non 200 series responses
            })
        }
    }
}


export const loadTectonSDK = async (tenant, moduleRoute = "tectonRoute.FamilyWallet.Main") => {

    if (!isQ2ServiceProvider(tenant, false)) {
        return;
    }

    if (window.Tecton) {
        console.log("Tecton SDK already loaded");
        return initTecton(moduleRoute);
    }

    const script = document.createElement("script");
    script.src = "https://cdn1.onlineaccess1.com/cdn/base/tecton/v1.38.0/q2-tecton-sdk.js";
    script.async = true;

    const scriptLoaded = new Promise((resolve, reject) => {
        script.onload = () => resolve(true);
        script.onerror = () => reject("Failed to load Tecton SDK");
    });

    document.head.appendChild(script);

    await scriptLoaded;
    console.log("Tecton SDK loaded successfully");

    return initTecton(moduleRoute);
};

export const initTecton = async (moduleRoute) => {
    const moduleIdParam = `tct-id=${moduleRoute}`;
    let urlWithModuleId = window.location.href;

    if (window.location.search) {
        if (!window.location.search.includes("tct-id")) {
            urlWithModuleId = `${window.location.href}&${moduleIdParam}`;
        }
    } else {
        urlWithModuleId = `${window.location.href}?${moduleIdParam}`;
    }

    if (urlWithModuleId) {
        window.history.pushState({ path: urlWithModuleId }, "", urlWithModuleId);
    }

    window.tecton = {};
    try {
        const capabilities = await window.Tecton.connect({});
        window.tecton.actions = capabilities.actions;
        window.tecton.sources = capabilities.sources;
        capabilities.actions.setFetching(false); // show iframe, stop spinner
        console.log("Tecton initialized successfully");
    } catch (err) {
        console.error("Tecton connection error:", err);
    }
};